module.exports = __webpack_public_path__ + "img/Smokescreen_Visuals_Logo.c71f39e3.jpg";